/* eslint-disable react/no-string-refs */
import Icon from '@cvent/nucleus-icon';
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';

export default class DialogContent extends React.Component {
  static propTypes = {
    message: PropTypes.string,
    subMessage: PropTypes.string,
    icon: PropTypes.string,
    iconModifier: PropTypes.string,
    children: PropTypes.node
  };
  componentDidMount() {
    const elem = document.getElementsByName('messageContainer') &&
      document.getElementsByName('messageContainer')[0];
    if (elem) {
      elem.focus();
    }
  }
  render() {
    const { message, subMessage, icon, iconModifier, children } = this.props;
    return (
      <div {...resolve(this.props, 'messageContainer')} name="messageContainer" tabIndex="-1">
        { icon &&
          <Icon
            icon={icon}
            modifier={resolve(this.props, 'messageIcon', iconModifier).className}
          />
        }
        {message && <div {...resolve(this.props, 'message')}>{message}</div>}
        {subMessage && <p {...resolve(this.props, 'subMessage')}>{subMessage}</p>}
        {children}
      </div>
    );
  }
}
